import {env} from './EnvirementConfig';
class PrefixPath{
    static APP_NAME = 'AAM';
    static API_BASE_URL = env.API_ENDPOINT_URL
    static LOCATION_API_BASE_URL = env.LOCATION_API_URL;
    static HUB_API_BASE_URL = env.HUB_API_ENDPOINT_URL;
    static App_URL = env.REACT_APP;
    static APP_PREFIX_PATH = '/app';
    static AUTH_PREFIX_PATH = '/auth';
}
export default PrefixPath;